import { Button, Image, Row, Typography, Flex, Space } from 'antd'
import moment from 'moment'
import { useContext } from 'react'
import { GenerateImgType, RenderTrainedInfoItemType } from '../../../types'
import { AppContext } from '../../../hooks/AppContext'

type Props = {
  item: RenderTrainedInfoItemType
  isRenderProcessing?: boolean
  handleListImgDownload?: (item: GenerateImgType[]) => void
}

const ImageItem = (props: Props) => {
  const { item, isRenderProcessing, handleListImgDownload } = props
  const { isMobile } = useContext(AppContext)

  const fontMobileStyle = {
    fontSize: 12,
    marginRight: 5
  }

  return (
    <>
      <Row className='bg-white items-center text-center'>
        <Row className='flex-[1] mt-1 justify-center '>
          <Flex className='mr-1 ml-1 mb-1 '>
            <Image src={item?.background_url} height={120} style={{ width: 'auto' }} />
          </Flex>
        </Row>
        <Row className='flex-[1] mt-1 justify-center '>
          <Flex className='mr-1 ml-1 mb-1 '>
            <Image src={item?.face_urls[0] ?? ''} height={120} style={{ width: 'auto' }} />
          </Flex>
        </Row>
        <Row className='flex-[1] justify-center'>
          {isRenderProcessing ? (
            <img src={require('../../../assets/loading.gif')} width={100} />
          ) : (
            <Typography style={isMobile ? fontMobileStyle : undefined}>
              {moment(item?.updated_at).format('YYYY/MM/DD HH:mm')}
            </Typography>
          )}
        </Row>
        {isRenderProcessing ? (
          <Row className='flex-[1.5] mt-1 justify-center'>
            <img className='contents-center' src={require('../../../assets/loading.gif')} width={100} />
          </Row>
        ) : (
          <Row className='flex-[1.5] mt-1 justify-center'>
            {item?.medias?.map((items) => (
              <Flex className='mr-1 ml-1 mb-1 '>
                <Image src={items?.url} height={120} style={{ width: 'auto' }} />
              </Flex>
            ))}
          </Row>
        )}
        <Row className='flex-[0.5] justify-center items-center'>
          {!isRenderProcessing && (
            <Button
              onClick={() => handleListImgDownload && handleListImgDownload(item?.medias)}
              type='primary'
              className='font-bold'
              size={isMobile ? 'small' : 'middle'}
              style={{
                ...(isMobile && {
                  fontSize: 8,
                  alignContent: 'center',
                  paddingLeft: 2,
                  paddingRight: 2,
                  textAlign: 'center',
                  alignSelf: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                  justifySelf: 'center',
                  justifyItems: 'center'
                })
              }}
            >
              ダウンロード
            </Button>
          )}
        </Row>
      </Row>
      <Row className='h-[1px] bg-[#5AAAFF]' />
    </>
  )
}

export default ImageItem
